import React from 'react';
import styled from 'styled-components';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, Autoplay, EffectCube } from 'swiper/modules';
import QuoteCard from './QuoteCard';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/effect-cube';

const QuoteCarousel = ({ quotes }) => {
  console.log('QuoteCarousel received quotes:', quotes);

  if (!quotes || !Array.isArray(quotes) || quotes.length === 0) {
    return (
      <CarouselContainer>
        <div style={{ color: 'white', textAlign: 'center', padding: '2rem' }}>
          <h3>No quotes available</h3>
          <p>Please check your connection or try again later.</p>
        </div>
      </CarouselContainer>
    );
  }

  return (
    <CarouselContainer>
      <StyledSwiper
        modules={[Navigation, Pagination, Autoplay, EffectCube]}
        spaceBetween={30}
        slidesPerView={1}
        navigation
        pagination={{ clickable: true }}
        autoplay={{
          delay: 6000,
          disableOnInteraction: false,
        }}
        effect="cube"
        cubeEffect={{
          shadow: true,
          slideShadows: true,
          shadowOffset: 20,
          shadowScale: 0.94,
        }}
        loop={true}
      >
        {quotes.map((quote) => {
          console.log('Rendering quote:', quote);
          return (
            <SwiperSlide key={quote.id}>
              <SlideContent>
                <QuoteCard quote={quote} />
              </SlideContent>
            </SwiperSlide>
          );
        })}
      </StyledSwiper>
    </CarouselContainer>
  );
};

const CarouselContainer = styled.div`
  width: 100%;
  max-width: 800px;
  margin: 0 auto;
  padding: 0;
  margin-top: 1rem;
`;

const StyledSwiper = styled(Swiper)`
  width: 100%;
  height: 300px; /* Reduced height to bring it up */

  .swiper-button-next,
  .swiper-button-prev {
    color: #d4af37; /* Match the golden theme */

    &:hover {
      color: var(--color-gold-light);
    }
  }

  .swiper-pagination-bullet {
    background-color: var(--color-secondary);
    opacity: 0.7;

    &-active {
      background-color: #d4af37; /* Match the golden theme */
      opacity: 1;
    }
  }

  .swiper-cube-shadow {
    background: rgba(0, 0, 0, 0.8);
    filter: blur(10px);
  }

  @media (max-width: 768px) {
    height: 280px;
  }
`;

const SlideContent = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 1rem;
`;

export default QuoteCarousel;
